import fr from 'facet-rest';
import { SearchableSelect } from 'Components/UI/Select/SearchableSelect';
import { BaseWizardStepOverride } from 'Views/Page/Content/Templates/BaseWizardStepOverride';

export default fr
  .metaOverride({ base: BaseWizardStepOverride })
  .typeOverride('picklist', {
    _component: () => SearchableSelect,
  });
